/**
 * One status pill for every page, so "failed" or "suspended" reads the same
 * everywhere. Unknown values fall back to neutral.
 */
type Tone = 'good' | 'progress' | 'wait' | 'bad' | 'neutral';

const TONE_OF: Record<string, Tone> = {
  // finished well
  delivered: 'good', active: 'good', completed: 'good', paid: 'good', verified: 'good',
  approved: 'good', streaming: 'good', ok: 'good', granted: 'good',
  // under way
  sent: 'progress', running: 'progress', sending: 'progress', processing: 'progress',
  // waiting on something
  pending: 'wait', queued: 'wait', draft: 'wait', scheduled: 'wait', paused: 'wait',
  degraded: 'wait', accepted: 'wait',
  // went wrong or stopped
  failed: 'bad', rejected: 'bad', expired: 'bad', suspended: 'bad', blocked: 'bad',
  cancelled: 'bad', overdue: 'bad', chargeback: 'bad', undelivered: 'bad',
  // over and done with
  terminated: 'neutral', closed: 'neutral', inactive: 'neutral', refunded: 'neutral',
};

const CLASSES: Record<Tone, string> = {
  good: 'bg-emerald-50 text-emerald-800 ring-emerald-600/20',
  progress: 'bg-sky-50 text-sky-800 ring-sky-600/20',
  wait: 'bg-amber-50 text-amber-800 ring-amber-600/20',
  bad: 'bg-red-50 text-red-800 ring-red-600/20',
  neutral: 'bg-slate-100 text-slate-700 ring-slate-500/20',
};

export function statusTone(value: string | null | undefined): Tone {
  return TONE_OF[(value || '').toLowerCase()] ?? 'neutral';
}

export function StatusBadge({ value }: { value: string | null | undefined }) {
  const label = value || '—';
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${CLASSES[statusTone(value)]}`}
    >
      {label}
    </span>
  );
}
